import {
  Card, CardContent, Divider,
} from '@mui/material';
import React from 'react';
import { ContactDetail } from '..';
import { CONTACT_INFO_DETAILS_STATUS } from '../../../consts/enums';
import ContactDetails from '../../ContactDetails';
import { ContactDetailsHeader } from '../ContactDetailsHeader';
import { contentStyle } from './style';

type ContactDetailsCardProps = {
    arrEmails: EmailItem[],
    editEmailArrayHandler?: (item :{
      id: string,
      value: string,
    }) => void,
    handleIsShowAddRowEmail?: () => void,
    handleDeleteEmailRow?: (itemId: string) => void,
    isShowNewRowEmail?: boolean,
    newValueEmail?: string,
    handleEmailChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
    handleConfirmClickEmail?: () => void,
    arrPhones: PhoneItem[],
    editPhoneArrayHandler?: (item :{
      id: string,
      value: string,
    }) => void,
    handleDeletePhoneRow?: (itemId: string) => void,
    isShowNewRowPhone?: boolean,
    newValuePhone?: string,
    handlePhoneChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
    handleConfirmClickPhone?: () => void,
    formErrors: ContactDetail,
    isErrorGetMissingContactDetails: boolean,
    errorMessage: string,
    onRequestMissingContactDetailsClick: () => void,
    status: ContactInfoStatus | '',
    showGetMissingContactDetails: boolean,
    isDisabled: boolean,
}

export const ContactDetailsCard = ({
  arrEmails,
  editEmailArrayHandler,
  handleIsShowAddRowEmail,
  handleDeleteEmailRow,
  isShowNewRowEmail,
  newValueEmail,
  handleEmailChange,
  handleConfirmClickEmail,
  arrPhones,
  editPhoneArrayHandler,
  handleDeletePhoneRow,
  isShowNewRowPhone,
  newValuePhone,
  handlePhoneChange,
  handleConfirmClickPhone,
  formErrors,
  isErrorGetMissingContactDetails,
  errorMessage,
  status,
  onRequestMissingContactDetailsClick,
  showGetMissingContactDetails,
  isDisabled,
}:ContactDetailsCardProps):JSX.Element => {
  const renderStatus = () => {
    if (isErrorGetMissingContactDetails) {
      return CONTACT_INFO_DETAILS_STATUS.FAILED;
    }

    return status;
  };

  return (
    <Card
      id="contact-info-active"
      style={ { marginTop: '32px', border: '1px solid rgba(229, 231, 235, 1)' } }
    >
      <ContactDetailsHeader
        status={ renderStatus() }
        errorMessage={ errorMessage }
        showGetMissingContactDetails={ showGetMissingContactDetails }
        onRequestMissingContactDetailsClick={ onRequestMissingContactDetailsClick }
        isDisabled={ isDisabled }
      />
      <Divider />
      <CardContent style={ contentStyle }>
        <ContactDetails
          arrEmails={ arrEmails }
          arrPhones={ arrPhones }
          editEmailArrayHandler={ editEmailArrayHandler }
          handleIsShowAddRowEmail={ handleIsShowAddRowEmail }
          handleDeleteEmailRow={ handleDeleteEmailRow }
          isShowNewRowEmail={ isShowNewRowEmail }
          newValueEmail={ newValueEmail }
          handleEmailChange={ handleEmailChange }
          handleConfirmClickEmail={ handleConfirmClickEmail }
          editPhoneArrayHandler={ editPhoneArrayHandler }
          handleDeletePhoneRow={ handleDeletePhoneRow }
          isShowNewRowPhone={ isShowNewRowPhone }
          newValuePhone={ newValuePhone }
          handlePhoneChange={ handlePhoneChange }
          handleConfirmClickPhone={ handleConfirmClickPhone }
          formErrors={ formErrors }
        />
      </CardContent>
    </Card>
  );
};

ContactDetailsCard.defaultProps = {
  editEmailArrayHandler: null,
  handleIsShowAddRowEmail: null,
  handleDeleteEmailRow: null,
  isShowNewRowEmail: null,
  newValueEmail: null,
  handleEmailChange: null,
  handleConfirmClickEmail: null,
  editPhoneArrayHandler: null,
  handleDeletePhoneRow: null,
  isShowNewRowPhone: null,
  newValuePhone: null,
  handlePhoneChange: null,
  handleConfirmClickPhone: null,
};
